const loginResponse = {
    "_id":"62870c38711f24000003295",
    "login":true,
    "isSuperAdmin":true,
    "isBackDoorUser": true,
    "userProfile":{
       "is_active":true,
       "date_of_joining":"2022-05-20T03:30:24.167Z",
       "date_of_retirement":"2022-05-20T03:30:24.167Z",
       "awards_and_recognition":[
          ""
       ],
       "fellowships_in_societies":[
          ""
       ],
       "fellowships_awarded":[
          ""
       ],
       "membership_in_scientific_societies":[
          
       ],
       "patents_published_or_awarded":[
          ""
       ],
       "id_created_at":"2022-05-20T03:30:24.167Z",
       "isSuperAdmin":true,
       "password":"redacted",
       "profile_picture":"https://res.cloudinary.com/dwckgkzdz/image/upload/v1604757274/buddha_wyz1ek.jpg",
       "is_technical":true,
       "phd_documents":[
          
       ],
       "other_documents":[
          
       ],
       "_id":"62870c38711f24000003295",
       "full_name":{
          "first_name":"Root",
          "last_name":"User"
       },
       "faculty_id":"backDoorUser",
       "father_name":"",
       "mother_name":"",
       "spouse_name":"",
       "date_of_birth":null,
       "email_id":"backdoor@gm.com",
       "residential_address":"",
       "department":"Mathematics",
       "aadhar_number":"",
       "pan_number":"",
       "relation_between_2_employee":"",
       "phd_details":{
          "year_of_phd":"",
          "college_of_phd":"",
          "phd_certificate":""
       },
       "no_of_phd_guided":{
          "as_main_supervisor":"",
          "as_co_supervisor":""
       },
       "no_of_papers_published":{
          "national":0,
          "international":0
       },
       "mobile_number":"9988779988",
       "gender":"Male",
       "subject_specialization":"",
       "net_slet_details":{
          "qualification_status":"No",
          "year_of_passing":"",
          "net_slet_id":""
       },
       "number_of_books_published":0,
       "reference_faculty":"testFaculty",
       "permissions":{
          "create_user":{
             "create":false,
             "update":false,
             "read":false,
             "delete":false
          },
          "news_notice":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          },
          "holiday":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          },
          "attendance":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          },
          "subject_and_class":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          },
          "timetable":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          },
          "approve_leave":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          },
          "salary":{
             "create":false,
             "update":false,
             "read":true,
             "delete":false
          }
       },
       "leave":{
          "cl":{
             "available_leave_count":8,
             "taken_leave_count":0,
             "applied_count":0
          },
          "pl":{
             "available_leave_count":10,
             "taken_leave_count":0,
             "applied_count":0
          },
          "el":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "sl":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "mtl":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "ptl":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "lwp":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "chcl":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "ccl":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          },
          "dl":{
             "available_leave_count":0,
             "taken_leave_count":0,
             "applied_count":0
          }
       },
       "__v":1
    }
 }

export {loginResponse};